@Service('ib-checkin-services-module',
    ['CommonsKeepAliveService', 'localStorageService'])

class CloseSessionService {

    constructor (
        private CommonsKeepAliveService: CommonsKeepAliveService,
        private localStorageService: angular.local.storage.ILocalStorageService
    ) {
    }

    closeSession = (): void => {
        const checkinId: string = this.localStorageService.get('flowId');
        this.CommonsKeepAliveService.closeSession(checkinId, true);
    };
}